import type {
  NavigateToRouteMessage,
  IframeInitializeMessage,
  IframeInitializationData,
} from "../../types";
import { PAYWALL_MESSAGE_TYPES, ROUTE_TEMPLATES } from "../../constants";

// Pure function: Create navigation message for dashboard
export const createDashboardNavigationMessage = (appId: string): NavigateToRouteMessage => {
  return {
    type: PAYWALL_MESSAGE_TYPES.NAVIGATE_TO_ROUTE,
    payload: { route: ROUTE_TEMPLATES.DASHBOARD(appId) },
  };
};

// Pure function: Create navigation message for profile creation
export const createProfileNavigationMessage = (appId: string): NavigateToRouteMessage => {
  return {
    type: PAYWALL_MESSAGE_TYPES.NAVIGATE_TO_ROUTE,
    payload: { route: ROUTE_TEMPLATES.CREATE_ACCOUNT(appId) },
  };
};

// Pure function: Create navigation message for pricing
export const createPricingNavigationMessage = (appId: string): NavigateToRouteMessage => {
  return {
    type: PAYWALL_MESSAGE_TYPES.NAVIGATE_TO_ROUTE,
    payload: { route: ROUTE_TEMPLATES.PRICING(appId) },
  };
};

// Pure function: Create iframe initialization message
export const createInitializationMessage = (
  data: IframeInitializationData
): IframeInitializeMessage => {
  return {
    type: PAYWALL_MESSAGE_TYPES.IFRAME_INITIALIZE,
    payload: data,
  };
};

// Pure function: Create navigation message for any route
export const createNavigationMessage = (route: string): NavigateToRouteMessage => {
  return {
    type: PAYWALL_MESSAGE_TYPES.NAVIGATE_TO_ROUTE,
    payload: { route },
  };
};